export const FILMS = [
  {
    id: "this-is-tenth-grade",
    title: "This Is Tenth Grade",
    year: "2026",
    role: "Writer / Director",
    runtime: "Short · 1:33",
    logline:
      "A short film about the importance of being you.",
    image:
      "https://customer-assets-m6fa6gv7.emergentagent.net/job_teen-stories/artifacts/uw8eqz5r_tenthgradethumbnail.png",
    festivals: [],
    reel: "https://youtu.be/9UWpEvXjnmQ",
  },
  {
    id: "can-you-see-me",
    title: "Can You See Me?",
    year: "2024",
    role: "Writer / Director",
    runtime: "Short · 15 min",
    logline:
      "A young soul, slowly disappearing inside the noise of the everyday, dares to ask the one question no one's been brave enough to answer.",
    image:
      "https://customer-assets.emergentagent.com/job_teen-stories/artifacts/mwkzfmuo_Screenshot%202026-06-05%20at%203.28.05%E2%80%AFPM.png",
    imageStyle: { filter: "sepia(0.20) saturate(1.15) contrast(1.0) brightness(1.25)" },
    festivals: ["Official Selection · Nehemiah Film Festival"],
    reel: "https://youtu.be/NPNFyPuqLCo",
  },
  {
    id: "david",
    title: "David",
    year: "2025",
    role: "Writer / Director",
    runtime: "Proof of Concept · 5 min",
    logline:
      "A withdrawn fourteen-year-old begins developing mysterious powers just as an ancient giant awakens beneath the Earth, forcing him to uncover the truth about who he is before humanity's oldest enemy returns.",
    image:
      "https://customer-assets.emergentagent.com/job_teen-stories/artifacts/5hmarqtp_DAVID-WIDE.jpg",
    festivals: [],
    reel: "https://vimeo.com/903956144",
  },
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1721701233113-85e8e91eb79b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxjaW5lbWF0aWMlMjBzaWxob3VldHRlJTIwZ29sZGVuJTIwaG91cnxlbnwwfHx8fDE3ODA2ODg1Nzl8MA&ixlib=rb-4.1.0&q=85";

export const ABOUT_IMAGE = "/about-jy.jpg";

export const ACTING_VIDEO =
  "https://customer-assets.emergentagent.com/job_teen-stories/artifacts/o46djiz8_jysportfolioversion.mp4";

export const CONTACT_EMAIL = "jytwright@gmail.com";
export const REEL_URL = "https://vimeo.com/929763291";
export const INSTAGRAM_URL = "https://www.instagram.com/jytwright/";
export const YOUTUBE_URL = "https://www.youtube.com/channel/UCnh8mR0bPeJSnN9UnOh1e3A";
